import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const proyectosData = [
  {
    id: 1,
    titulo: "DeKarolis.com",
    descripcion:
      "Mi portafolio personal donde muestro mis proyectos y habilidades.",
    imagen:
      "https://res.cloudinary.com/dhjl9tw4r/image/upload/v1748342113/Captura_de_pantalla_2025-05-27_123500_tp2f6m.png",
    detalles:
      "Este sitio web ha sido desarrollado por mí, Karolis Tamosaitis, como una plataforma personal para presentar de forma clara y profesional mi perfil como desarrollador web full stack junior. Está construido utilizando React para el frontend, lo que permite una navegación fluida, rápida y dinámica.",
    url: "https://www.dekarolis.com/",
  },
  {
    id: 2,
    titulo: "MundoIdeas.com",
    descripcion:
      "Un sitio web de comercio electrónico para vender productos para niños.",
    imagen:
      "https://res.cloudinary.com/dhjl9tw4r/image/upload/v1748182477/Captura_de_pantalla_2025-05-25_161402_gywk7z.png",
    detalles:
      'Este proyecto consiste en el desarrollo completo de una tienda online creada con PrestaShop, la plataforma de comercio electrónico más utilizada en Europa. Me encargué personalmente de todas las fases del desarrollo y configuración del sitio, tanto a nivel visual como funcional. Utilicé la herramienta de diseño "Click and Drop" de PrestaShop para construir un frontend personalizado, atractivo y adaptado a dispositivos móviles, optimizando la experiencia de usuario sin depender de plantillas prefabricadas. Esto me permitió crear una tienda con una identidad visual única y profesional.',
    url: "https://MundoIdeas.com/"
  },
  {
    id: 3,
    titulo: "stepbystep.dekarolis.com",
    descripcion:
      "es una aplicación web full-stack de gestión de tareas con sistema de usuarios, tablero Kanban y funcionalidades sociales. Desarrollada como proyecto personal de aprendizaje y portafolio.",
    imagen:
      "https://res.cloudinary.com/dhjl9tw4r/image/upload/v1780391936/stebbystep_dtfppt.png",
    detalles:
      "Frontend: Angular 19 componentes standalone, Angular Signals, Tailwind CSS Backend: ASP.NET Core Web API.NET Base de datos: PostgreSQL con Entity Framework Core Autenticación: JWT JSON Web Tokens Testing: NUnit + Moq Control de versiones: Git - GitHub.",
      url: "https://stepbystep.dekarolis.com/"
  },
];

function Proyectos() {
  const [modalAbierto, setModalAbierto] = useState(false);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);

  const abrirModal = (proyecto) => {
    setProyectoSeleccionado(proyecto);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setProyectoSeleccionado(null);
  };

  return (
    <div id="proyectos" className="max-w-6xl px-2 mx-auto mb-36 sm:px-4">
      <h2 className="mb-6 text-2xl font-bold text-center sm:text-3xl sm:mb-8">
        Mis Proyectos
      </h2>
      <p className="mb-6 text-sm text-center text-gray-300 sm:text-base sm:mb-8">
        Puedes acceder a información detallada de cada proyecto haciendo clic en
        ellos.
      </p>
      <div className="grid grid-cols-1 gap-6 proyectos-grid sm:grid-cols-2 lg:grid-cols-2 sm:gap-8">
        {proyectosData.map((proyecto) => (
          <motion.div
            key={proyecto.id}
            className="overflow-hidden transition-transform duration-200 bg-gray-800 rounded-lg shadow-lg cursor-pointer hover:scale-105 hover:shadow-2xl"
            onClick={() => abrirModal(proyecto)}
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1 }}
          >
            <img
              src={proyecto.imagen}
              alt={proyecto.titulo}
              className="object-cover w-full h-48 sm:h-60"
            />
            <div className="p-3 sm:p-4">
              <h3 className="mb-2 text-lg font-semibold text-gray-300 sm:text-xl">
                {proyecto.titulo}
              </h3>
              <p className="text-sm text-gray-300 sm:text-base">
                {proyecto.descripcion}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      <AnimatePresence>
        {modalAbierto && proyectoSeleccionado && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center px-2 bg-black/70 backdrop-blur-sm"
            onClick={cerrarModal}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 rounded-2xl shadow-2xl w-full max-w-lg lg:w-[40%] p-0 overflow-hidden border border-gray-700"
              onClick={(e) => e.stopPropagation()}
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.92, opacity: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 25 }}
            >
              <div className="relative w-full bg-gray-700 h-44 sm:h-60">
                <img
                  src={proyectoSeleccionado.imagen}
                  alt={proyectoSeleccionado.titulo}
                  className="object-cover object-top w-full h-full rounded-t-2xl"
                />

                <button
                  className="absolute z-10 p-2 text-gray-400 transition-colors rounded-full shadow top-2 right-2 hover:text-red-500 bg-gray-900/70 focus:outline-none focus:ring-2 focus:ring-red-400"
                  onClick={cerrarModal}
                  aria-label="Cerrar"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-t-2xl" />
              </div>

              <div className="p-6">
                <h2 className="flex items-center gap-2 mb-2 text-2xl font-bold text-gray-100">
                  <span className="inline-block w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                  {proyectoSeleccionado.titulo}
                </h2>

                <p className="mb-2 text-base leading-relaxed text-gray-300">
                  {proyectoSeleccionado.descripcion}
                </p>

                <hr className="my-3 border-gray-700" />

                <p className="text-sm text-gray-400">
                  {proyectoSeleccionado.detalles}
                </p>

                {proyectoSeleccionado.url && (
                  <div className="flex justify-center mt-5 ">
                    <a
                      href={proyectoSeleccionado.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-5 py-2 font-medium transition rounded-lg bg-zinc-800 hover:bg-zinc-900"
                    >
                      Visitar página web
                    </a>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Proyectos;
